import React from 'react';

const TemperatureIcon = ({
  color = '#FFFFFF'
}) => {
  return (
    <svg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M74.375 75.37h-9.25c-.552 0-1-.443-1-1.01v-1.98c0-.558.44-1.01 1-1.01h9.25V61.33h-9.25c-.552 0-1-.443-1-1.01v-1.98c0-.558.44-1.01 1-1.01h9.25V47.29h-9.25c-.552 0-1-.443-1-1.01V44.3c0-.558.44-1.01 1-1.01h9.25V33.25h-9.25c-.552 0-1-.443-1-1.01v-1.98c0-.558.44-1.01 1-1.01h9.25v-9c0-5.66-4.59-10.25-10.25-10.25s-10.25 4.59-10.25 10.25v67.414C49.71 90.78 47 95.74 47 101.344c0 9.503 7.653 17.156 17.093 17.156 9.504 0 17.157-7.653 17.157-17.094 0-5.667-2.71-10.625-6.875-13.742V75.37z'
        fill={color} fillRule='evenodd'
      />
    </svg>
  );
};

export default TemperatureIcon;



// WEBPACK FOOTER //
// ./src/app/components/atoms/icons/TemperatureIcon/TemperatureIcon.js